import { render, staticRenderFns } from "./AnnualLeavePlanDetails.vue?vue&type=template&id=52f02d48"
import script from "./AnnualLeavePlanDetails.vue?vue&type=script&lang=js"
export * from "./AnnualLeavePlanDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnualLeavePlanDetails.vue?vue&type=style&index=0&id=52f02d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports